import React, { useMemo, useState } from "react";

import { useNavigate } from "react-router-dom";

import Swal from "sweetalert2";

import "../styles/public-pooja-booking.css";

import "../styles/public-pooja-account.css";

const API_BASE = (process.env.REACT_APP_API_BASE || "https://webcontrol.suvidham.in/api").replace(/\/$/, "");

const postJSON = async (endpoint, body) => {
  const response = await fetch(`${API_BASE}/${endpoint}`, {method:"POST",headers:{"Content-Type":"text/plain;charset=UTF-8"},body:JSON.stringify(body)});
  const raw = await response.text(); let data;
  try { data = JSON.parse(raw); } catch { throw new Error(`Invalid API response (${response.status})`); }
  if (!response.ok || data.status !== "success") throw new Error(data.message || `Request failed (${response.status})`);
  return data;
};
const loadRazorpay = () => new Promise((resolve,reject) => {
  if(window.Razorpay) return resolve();
  const old=document.querySelector('script[data-razorpay-checkout]');
  if(old) { old.addEventListener('load',resolve,{once:true}); old.addEventListener('error',()=>reject(new Error('Unable to load Razorpay')),{once:true}); return; }
  const s=document.createElement('script');s.src='https://checkout.razorpay.com/v1/checkout.js';s.async=true;
  s.dataset.razorpayCheckout='1';s.onload=resolve;s.onerror=()=>reject(new Error('Unable to load Razorpay checkout'));
  document.body.appendChild(s);
});

const today = () => new Date().toISOString().slice(0, 10);

const money = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

const BIRTH_STARS = ["Ashwathi / അശ്വതി","Bharani / ഭരണി","Karthika / കാർത്തിക","Rohini / രോഹിണി","Makayiram / മകയിരം","Thiruvathira / തിരുവാതിര","Punartham / പുണർതം","Pooyam / പൂയം","Ayilyam / ആയില്യം","Makam / മകം","Pooram / പൂരം","Uthram / ഉത്രം","Atham / അത്തം","Chithira / ചിത്തിര","Chothi / ചോതി","Vishakham / വിശാഖം","Anizham / അനിഴം","Thrikketta / തൃക്കേട്ട","Moolam / മൂലം","Pooradam / പൂരാടം","Uthradam / ഉത്രാടം","Thiruvonam / തിരുവോണം","Avittam / അവിട്ടം","Chathayam / ചതയം","Pooruruttathi / പൂരുരുട്ടാതി","Uthrattathi / ഉത്രട്ടാതി","Revathi / രേവതി"];

const emptyCustomer = { customer_name:"", mobile:"", email:"", address:"", city:"", state:"Kerala", pin_code:"", password:"", confirm_password:"" };

export default function PoojaReview(){

  const nav=useNavigate();

  const [cart,setCart]=useState(()=>JSON.parse(localStorage.getItem("pooja_cart")||"[]"));

  const [customer,setCustomer]=useState(()=>({ ...emptyCustomer, ...JSON.parse(localStorage.getItem("pooja_customer")||"{}") }));

  const [busy,setBusy]=useState(false); const [msg,setMsg]=useState("");

  const save=(c)=>{setCart(c);localStorage.setItem("pooja_cart",JSON.stringify(c));};

  const update=(key,patch)=>save(cart.map(x=>x.key===key?{...x,...patch}:x));

  const groups=useMemo(()=>{const m=new Map();cart.forEach(i=>{const k=`${(i.devotee_name||"").trim().toLowerCase()}|${i.birth_star||""}`;if(!m.has(k))m.set(k,{id:k,name:i.devotee_name||"Devotee",star:i.birth_star||"",items:[]});m.get(k).items.push(i)});return [...m.values()]},[cart]);

  const total=useMemo(()=>cart.reduce((s,i)=>s+Number(i.unit_rate||0)*Number(i.quantity||1),0),[cart]);

  const updateGroup=(g,patch)=>{const keys=new Set(g.items.map(x=>x.key));save(cart.map(x=>keys.has(x.key)?{...x,...patch}:x));};

  const minDate=i=>i.date_mode==="SINGLE"?i.single_date:(i.date_mode==="RANGE"&&i.range_start>today()?i.range_start:today());

  const maxDate=i=>i.date_mode==="SINGLE"?i.single_date:(i.date_mode==="RANGE"?i.range_end:undefined);

  const field=(k,v)=>setCustomer(c=>({...c,[k]:v}));

  const validationAlert=(message)=>Swal.fire({icon:"warning",title:"Required Information",text:message,confirmButtonText:"OK"});

  const submit=async()=>{

    setMsg("");

    if(!cart.length) return validationAlert("Please select at least one vazhipad.");

    if(cart.some(i=>!String(i.devotee_name||"").trim()||!i.birth_star||!i.pooja_date)) return validationAlert("Please complete name, birth star and pooja date for every item.");

    if(cart.some(i=>Number(i.allow_rate_change)===1 && Number(i.unit_rate||0)<=0)) return validationAlert("Please enter amount for Donation / E-Kanikka. Amount is mandatory and must be greater than 0.");

    if(!customer.customer_name.trim()) return validationAlert("Enter name in Contact & Payment.");

    if(!/^[6-9]\d{9}$/.test(customer.mobile)) return validationAlert("Enter a valid 10 digit mobile number.");

    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(customer.email.trim())) return validationAlert("Enter a valid e-mail address.");

    if(!customer.address.trim()||!customer.city.trim()||!customer.state.trim()) return validationAlert("Address, City and State are required.");

    if(!/^[1-9]\d{5}$/.test(customer.pin_code)) return validationAlert("Enter a valid 6 digit PIN code.");

    if(customer.password.length<8) return validationAlert("Password must contain at least 8 characters.");

    if(customer.password!==customer.confirm_password) return validationAlert("Passwords do not match.");

    setBusy(true);

    try{

      localStorage.setItem("pooja_customer",JSON.stringify({...customer,password:"",confirm_password:""}));

      const r=await fetch(`${API_BASE}/public_pooja_order_save.php`,{method:"POST",headers:{"Content-Type":"text/plain;charset=UTF-8"},body:JSON.stringify({...customer,devotee_name:customer.customer_name,birth_star:cart[0]?.birth_star||"",website:"",items:cart})});

      const raw=await r.text(); let data; try{data=JSON.parse(raw)}catch{throw new Error(`Server returned ${r.status}: ${raw||"Invalid response"}`)} if(!r.ok||data.status!=="success") throw new Error(data.message||`Unable to save booking (${r.status})`);

      const token = data.checkout_token;
    if (!token) throw new Error("Booking API did not return checkout_token. Upload the included PHP and execute the SQL migration.");
    localStorage.setItem("pooja_pending_payment", JSON.stringify({order_no:data.order_no,checkout_token:token}));
    const checkout = await postJSON("razorpay_create_order.php", {order_no:data.order_no,checkout_token:token});
    await loadRazorpay();
    setBusy(false);
    const rzp = new window.Razorpay({
      key: checkout.key_id,
      amount: checkout.amount,
      currency: "INR",
      name: "Online Pooja Booking",
      description: `Booking ${data.order_no}`,
      order_id: checkout.razorpay_order_id,
      prefill: { name: customer.customer_name, email: customer.email, contact: customer.mobile },
      theme: { color: "#146e7c" },
      modal: { ondismiss: () => Swal.fire({ icon:"info", title:"Payment not completed", text:"Your booking is pending. Please retry payment from the review page." }) },
      handler: async (response) => {
        try {
          const verified = await postJSON("razorpay_verify_payment.php", { ...response, order_no:data.order_no, checkout_token:token });
          if (verified.payment_status === "SUCCESS") {
            localStorage.removeItem("pooja_pending_payment");
            localStorage.removeItem("pooja_cart");
            setCart([]);
            nav("/pooja-success",{state:{...verified, order_no:data.order_no, total_amount:verified.total_amount, payment_status:"SUCCESS"}});
          } else {
            Swal.fire({icon:"info",title:"Payment processing",text:"Payment confirmation is pending. Do not pay again until the status is checked."});
          }
        } catch(err) { Swal.fire({icon:"warning", title:"Verification pending",text:err.message+" Please check your booking status before retrying."}); }
      }
    });
    rzp.on("payment.failed", (r) => Swal.fire({icon:"error",title:"Payment failed",text:r.error?.description || "Please try again."}));
    rzp.open();
  }catch(e){setMsg(e.message);Swal.fire({icon:"error",title:"Unable to Proceed",text:e.message||"Something went wrong.",confirmButtonText:"OK"})}finally{setBusy(false)}

  };

  return <div className="pb-page"><div className="row">

    <div className="col-md-8">

      <section className="pb-hero compact"><div><span className="pb-kicker">REVIEW BOOKING</span><h1>Review devotees & vazhipads</h1><p>Bookings are separated by devotee. Every item can still be edited.</p></div><div className="pb-total"><small>Grand total</small><strong>{money(total)}</strong><span>{cart.length} items • {groups.length} devotee{groups.length===1?"":"s"}</span></div></section>

      <div className="pb-review-actions"><button onClick={()=>nav("/online-pooja-booking")}><i className="fa fa-plus"/> Select More Vazhipads</button><button className="danger" disabled={!cart.length} onClick={()=>window.confirm("Remove all selected vazhipads?")&&save([])}><i className="fa fa-trash"/> Clear All</button></div>

      {!cart.length?<div className="pb-empty"><h3>No vazhipads selected</h3><button onClick={()=>nav("/online-pooja-booking")}>Start Booking</button></div>:

      <div className="pb-person-groups">{groups.map((g,index)=><section className="pb-person-card" key={g.id}>

        <header className="pb-person-head"><div className="pb-person-avatar">{index+1}</div><div><small>DEVOTEE</small><h2>{g.name}</h2><p>{g.star||"Birth star not selected"} • {g.items.length} vazhipad{g.items.length===1?"":"s"}</p></div><button className="pb-person-delete" onClick={()=>window.confirm(`Remove all vazhipads for ${g.name}?`)&&save(cart.filter(x=>!new Set(g.items.map(y=>y.key)).has(x.key)))}><i className="fa fa-trash"/> Remove Person</button></header>

        <div className="pb-person-common"><label>Name *<input value={g.name} onChange={e=>updateGroup(g,{devotee_name:e.target.value})}/></label><label>Birth Star *<select value={g.star} onChange={e=>updateGroup(g,{birth_star:e.target.value})}><option value="">Select birth star</option>{BIRTH_STARS.map(s=><option key={s}>{s}</option>)}</select></label></div>

        <div className="pb-person-items">{g.items.map(i=><article className="pb-review-item pb-review-item-person" key={i.key}><div className="pb-review-icon">ॐ</div><div className="pb-review-main"><div className="pb-review-title"><div><h3>{i.vazhipad_name}</h3><p>{i.prathishta_name}</p></div><button onClick={()=>save(cart.filter(x=>x.key!==i.key))}><i className="fa fa-trash"/></button></div><div className="pb-edit-row pb-edit-row-expanded">

          <label>Name<input value={i.devotee_name||""} onChange={e=>update(i.key,{devotee_name:e.target.value})}/></label>

          <label>Birth Star<select value={i.birth_star||""} onChange={e=>update(i.key,{birth_star:e.target.value})}><option value="">Select</option>{BIRTH_STARS.map(s=><option key={s}>{s}</option>)}</select></label>

          <label>Pooja Date<input type="date" min={minDate(i)} max={maxDate(i)} value={i.pooja_date||today()} onChange={e=>update(i.key,{pooja_date:e.target.value})}/></label>

          <label>Thidhi<input value={i.thidhi||""} onChange={e=>update(i.key,{thidhi:e.target.value})} placeholder="Optional"/></label>

          <label>Quantity<input type="number" min="1" max="999" value={i.quantity} onChange={e=>update(i.key,{quantity:Math.max(1,Math.min(999,Number(e.target.value)||1))})}/></label>

          {Number(i.allow_rate_change)===1&&<label>Amount *<input type="number" min="1" max="999999" value={i.unit_rate} onChange={e=>update(i.key,{unit_rate:Number(e.target.value)||0})}/></label>}

          <div className="pb-line-total"><small>Amount</small><strong>{money(Number(i.unit_rate)*Number(i.quantity))}</strong></div>

        </div></div></article>)}</div>

      </section>)}</div>}

    </div>

    <div className="col-md-4"><aside className="pb-checkout pb-checkout-bottom payarea"><div className="pay-100"><h2 className="pay-title">Contact & Payment</h2><hr/></div>

      <div className="pb-contact-grid">

        <label>Full Name *<input value={customer.customer_name} onChange={e=>field("customer_name",e.target.value)} /></label>

        <label>Mobile Number *<input inputMode="numeric" maxLength="10" value={customer.mobile} onChange={e=>field("mobile",e.target.value.replace(/\D/g,"").slice(0,10))}/></label>

        <label>E-mail *<input type="email" value={customer.email} onChange={e=>field("email",e.target.value)}/></label>

        <label>Address for Communication *<textarea rows="3" value={customer.address} onChange={e=>field("address",e.target.value)}/></label>

        <label>City *<input value={customer.city} onChange={e=>field("city",e.target.value)}/></label>

        <label>State *<input value={customer.state} onChange={e=>field("state",e.target.value)}/></label>

        <label>PIN Code *<input inputMode="numeric" maxLength="6" value={customer.pin_code} onChange={e=>field("pin_code",e.target.value.replace(/\D/g,"").slice(0,6))}/></label>

        <label>Password *<input type="password" value={customer.password} onChange={e=>field("password",e.target.value)} placeholder="Minimum 8 characters"/></label>

        <label>Confirm Password *<input type="password" value={customer.confirm_password} onChange={e=>field("confirm_password",e.target.value)}/></label>

      </div>

      <p className="pb-account-note">This mobile number + password becomes the customer's login. For an existing mobile number, enter the existing password.</p>

      <div className="pb-order-total pay-100"><span>Total Amount</span><strong>{money(total)}</strong></div>

      <button className="pb-pay" disabled={busy||!cart.length} onClick={submit}>{busy?"Saving…":"Proceed to Payment"}</button>

    </aside></div>

  </div></div>;

}
